import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "src/@types/form";

interface Props extends ISelectOption {
  onClick: (value: ISelectOption["value"]) => void;
}
export const SelectedItem: FC<Props> = ({ value, label, onClick }) => {
  const { t } = useTranslation();

  const title =
    typeof label === "string" ? label : t(label.i18nKey, label.i18nParams);

  const handleClick = () => onClick(value);

  return (
    <span
      className="flex items-center px-3 py-2 h-7 text-base leading-normal text-white-base bg-purple-base cursor-pointer rounded-20"
      onClick={handleClick}
    >
      {title}
    </span>
  );
};
